module.exports = __webpack_public_path__ + "static/img/guide_mp_s.f235d5ca.png";